<template>
    <section class=" ">
        <Dialog :initialFocus="registerButtonRef" as="div" class="relative z-100">

            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black/90" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out absolute "
                        enter-from="opacity-0 scale-95 bottom-full" enter-to="opacity-100 scale-100 bottom-[35%]"
                        leave="duration-200 ease-in absolute" leave-from="opacity-100 scale-100 bottom-[35%]"
                        leave-to="opacity-0 scale-95 bottom-full">
                        <DialogPanel
                            class="w-full max-w-md transform  rounded-2xl bg-white p-6 text-start align-middle shadow-xl transition-all">
                            <a role="button" @click="cancel()"
                                class="absolute md:-top-0 -top-10 md:-right-[8%] right-0 ">
                                <img src="../../assets/images/icons/ic-close-light.svg" width="21" height="21" />
                            </a>

                            <!-- Start Register Form -->
                            <div class=" text-secondary">
                                <form @submit.prevent="register">
                                    <!-- Full Name input -->
                                    <div class="mb-6  ">
                                        <label for="f-name" class="text-sm  text-secondary">
                                            {{t('inputs.Your_Name')}}
                                            <span v-if="v$.name.$error" class="text-red">*</span>
                                        </label>
                                        <input type="text" name="f-name" autocomplete="off"
                                            class="form-control transition ease-in-out focus:ring-[#F6F6F6] focus:bg-white focus:gray-300 placeholder-dark-2/20 focus:border-[#F6F6F6]"
                                            :placeholder="t('inputs.name_place_holder')"  v-model="v$.name.$model" />
                                        <p v-if="v$.name.$error"
                                            class="input-err m-0 mt-1 block text-xs text-red font-regular"
                                            v-for="error of v$.name.$errors" :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>

                                    <!-- Email  input -->
                                    <div class="mb-6  ">
                                        <label for="email" class="text-sm  text-secondary">
                                            {{t('inputs.Email')}} 
                                            <span v-if="v$.email.$error" class="text-red">*</span>
                                        </label>
                                        <input type="text" name="email" autocomplete="nope"
                                            class="form-control transition ease-in-out focus:ring-[#F6F6F6] focus:bg-white focus:gray-300 placeholder-dark-2/20 focus:border-[#F6F6F6]"
                                            :placeholder="t('inputs.email_place_holder')"
                                            v-model.trim="v$.email.$model" />
                                        <p v-if="v$.email.$error"
                                            class="input-err m-0 mt-1 block text-xs text-red font-regular"
                                            v-for="error of v$.email.$errors" :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <!-- Phone No. input -->

                                    <div class="mb-6  ">
                                        <label for="phone_number" class="text-sm  text-secondary">
                                            {{t('inputs.Phone_no')}}
                                            <span v-if="v$.phone_number.$error" class="text-red">*</span>
                                        </label>
                                        <input type="text" name="phone_number"
                                            class="form-control transition ease-in-out focus:ring-[#F6F6F6] focus:bg-white focus:gray-300 placeholder-dark-2/20 focus:border-[#F6F6F6]"
                                            :placeholder="t('inputs.phone_place_holder')"
                                            v-model.trim="v$.phone_number.$model" />
                                        <p v-if="v$.phone_number.$error"
                                            class="input-err m-0 mt-1 block text-xs text-red font-regular"
                                            v-for="error of v$.phone_number.$errors" :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>

                                    <!-- Password input -->
                                    <div class="mb-6">
                                        <label for="password" class="text-sm  text-secondary">
                                            {{t('inputs.Password')}}
                                            <span v-if="v$.password.$error" class="text-red">*</span>
                                        </label>

                                        <div class="relative w-full">
                                            <!-- show password button -->
                                            <div class="absolute inset-y-0 end-0 flex items-center px-2">
                                                <input class="!hidden js-password-toggle" id="toggle" type="checkbox"
                                                    @change="showPassword()" />
                                                <label
                                                    class="flex flex-col items-center rounded px-2 py-1 cursor-pointer"
                                                    for="toggle">
                                                    <img v-if="!isShowPassword"
                                                        src="../../assets/icons/ic-show-pass.svg" />
                                                    <font-awesome-icon v-else icon="eye-slash"
                                                        class="h-6 w-6 text-gray-400 text-base	" />
                                                </label>
                                            </div>
                                            <!-- password input -->
                                            <input :type="isShowPassword ? 'text' : 'password'" name="password" 
                                                class="form-control appearance-none !pe-16 transition ease-in-out focus:ring-[#F6F6F6] focus:bg-white focus:gray-300 placeholder-dark-2/20 focus:border-[#F6F6F6] js-password"
                                                id="password" autocomplete="new-password" :placeholder="t('inputs.Password_place_holder')" 
                                                @keydown.space.prevent v-model="v$.password.$model" />
                                        </div>
                                        <!-- password validation -->
                                        <p v-if="v$.password.$error"
                                            class="input-err m-0 mt-1 block text-xs text-red font-regular"
                                            v-for="error, index of v$.password.$errors" :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>

                                    <div class="flex items-center justify-between my-8">
                                        <default-checkbox name="terms_accepted" :hasErr="v$.terms_accepted.$error"
                                            v-model="v$.terms_accepted.$model">
                                            {{t('messages.terms_message')}}
                                        </default-checkbox>
                                    </div>

                                    <!-- Submit button -->
                                    <button type="submit" ref="registerButtonRef"
                                        class="inline-block mb-6 px-7 py-3 bg-primary text-secondary font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-secondary hover:text-white hover:shadow-lg  focus:shadow-lg focus:outline-none focus:ring-0  active:shadow-lg transition duration-150 ease-in-out w-full"
                                        data-mdb-ripple="true" data-mdb-ripple-color="light">
                                        {{t('buttons.REGISTER')}}
                                    </button>


                                    <div class="text-center flex justify-center items-center">
                                        <span class="me-2 text-sm">{{t('messages.Have_Account')}}</span>
                                        <a role="button" class="text-secondary font-medium text-sm hover:underline"
                                            @click="openLoginModal">
                                            {{t('buttons.Login')}}
                                        </a>
                                    </div>
                                </form>
                            </div>
                            <!-- End Register Form -->

                        </DialogPanel>
                    </TransitionChild>

                </div>
            </div>
        </Dialog>

        <!-- loader -->
        <Loader :modalIsOpen="isLoading" :initFocusedRef="registerButtonRef" class="" :widthSM="true"></Loader>
    </section>

</template>

<script>
import { ref, reactive, computed } from 'vue'
import { useI18n } from "vue-i18n";

import { useRouter } from "vue-router"
import { useStore } from "vuex"
import Routes from '@/common/Routes'
import Response from "@/common/Response"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import DefaultCheckbox from "@/components/atoms/inputs/checkbox/DefaultCheckbox"
import Loader from "@/components/atoms/Loader";

//form validations
import useValidate from '@vuelidate/core'
import { required, email, minLength, maxLength, sameAs, helpers, or, and } from '@vuelidate/validators'

import {
    Dialog,
    DialogPanel,
    TransitionChild,
    DialogTitle
} from '@headlessui/vue';

export default {
    name: "registration-form",
    components: {
        Loader,
        DefaultCheckbox,
        FontAwesomeIcon,
        Dialog,
        DialogPanel,
        TransitionChild,
        DialogTitle
    },
    emits: ["openLoginModal", "openOTPModal", "openSendEmailModal", "closeModals"],

    setup(_, { emit }) {
        const { t } = useI18n();
        const store = useStore()
        const router = useRouter()
        const isLoading = ref(false)
        const isShowPassword = ref(false)
        const registerForm = reactive({
            name: '',
            email: '',
            phone_number: '',
            password: '',
            terms_accepted: false
        })
        const registerButtonRef = ref()
        // form validations
        const fullNameValidation = helpers.regex(/^[\p\u0600-\u06FF-a-zA-Z\p{N}]+(?:\s?[\p{N}\p\u0600-\u06FF-a-zA-Z])*$/)
        const phoneValidation = helpers.regex(/^([0-9\s\-\+\(\)]*)$/);

        const rules = computed(() => {
            return {
                name: {
                    minLength: helpers.withMessage(t('messages.minLength_4'), minLength(4)),
                    maxLength: helpers.withMessage(t('messages.maxLength_40'), maxLength(40)),
                    fullNameValidation: helpers.withMessage(t('messages.name_is_Invalid'), fullNameValidation)
                },
                email: {
                    required: helpers.withMessage(t('messages.email_is_required'), required),
                    email: helpers.withMessage(t('messages.email_is_Invalid'), email)
                },
                phone_number:{
                    required: helpers.withMessage(t('messages.phone_is_required'), required),
                    phoneValidation: helpers.withMessage(t('messages.phone_is_Invalid'), phoneValidation)
                },
                password: {
                    required: helpers.withMessage(t('messages.Password_required'), required),
                    minLength: helpers.withMessage(t('messages.minLength_6'), minLength(6)),
                },
                terms_accepted: { sameAs: sameAs(true) }
            }
        })
        const v$ = useValidate(rules, registerForm)

        //toggle show password
        const showPassword = function () {
            const password = document.getElementById('password')
            if (password.type === 'password') {
                isShowPassword.value = true
            } else {
                isShowPassword.value = false
            }
            password.focus()
        }

        const register = async function () {
            const isValid = await this.v$.$validate()
            const isDirty = await this.v$.$dirty

            if (isValid && isDirty) {
                isLoading.value = true
                //send this request with verify OTP Action
                await store.dispatch("register", {
                    email: registerForm.email,
                    phone_number: registerForm.phone_number,
                    password: registerForm.password,
                    terms_accepted: registerForm.terms_accepted,
                    user_hash: store.getters.deviceToken,
                    name: registerForm.name,

                }).then((res) => {
                    if (res?.data) {
                        //save user data
                        store.commit("setUser", { ...res.data.data, token: res.data.token })

                        //open and send otp to client mobile
                        emit('openOTPModal')

                        //close loader
                        isLoading.value = false

                        //display success toaster
                        new Response({ message: t('messages.Account_Created_Successfully') }).displaySuccess()

                    } else {
                        isLoading.value = false
                    }
                }).catch((err) => {
                    new Response({ message: t('messages.Internal_Error') }).displayErrors()

                    isLoading.value = false
                })
            }
        }

        return {
            t,
            registerButtonRef,
            isLoading,
            openLoginModal() {
                emit('openLoginModal')
            },
            cancel() {
                emit('closeModals')
            },
            //form
            registerForm, v$,
            isShowPassword,
            showPassword,
            register,
        }
    },
}
</script>

<style scoped lang="scss">
input {
    @apply block w-full px-4 mt-1 text-sm font-normal text-gray-700 bg-clip-padding border border-solid rounded m-0 focus:outline-none border-[#F6F6F6] bg-[#F6F6F6] focus:text-secondary;
}
</style>